@import "../fonts.css";
@import "../colors.css";

/* Note: local class names (.btn--primary, .btn-outlined, etc.) must be used outside of the :global() to work properly */

.button-base {
	background: none;
	cursor: pointer;
	border: none;
}

.button-base:focus-visible {
	outline: 2px solid var(--focus-outline-color-dark);
	outline-offset: 2px;
}

.button-base:disabled {
	cursor: default;
	pointer-events: none;
}

:global(.MuiButton-root).core-btn {
	font-style: normal;
	font-weight: 400;
	font-size: 13px;
	line-height: 18px;
	text-transform: none;

	padding-left: 13px;
	padding-right: 13px;
	border-style: solid;
	border-radius: 4.5px;

	display: inline-flex;
	align-items: center;

	transition-duration: 150ms;
}

:global(.MuiButton-root).core-btn.outlined {
	border-width: 2px;
}

:global(.MuiButton-root).core-btn.contained:global(.Mui-disabled) {
	background: #e5e7eb;
	color: #9ca3af;
}

.core-btn:global(.MuiButton-root):focus-visible {
	outline: 2px solid var(--focus-outline-color-dark);
	outline-offset: 2px;
}

.core-btn.small {
	padding-top: 6.5px;
	padding-bottom: 6.5px;
}

.core-btn.small:has(svg) {
	padding-top: 4.5px;
	padding-bottom: 4.5px;
}

.core-btn.small :global(.MuiSvgIcon-root) {
	font-size: 22px;
}

.core-btn.contained.small {
	padding-top: 8.5px;
	padding-bottom: 8.5px;
}

.core-btn.contained.small:has(svg) {
	padding-top: 6.5px;
	padding-bottom: 6.5px;
}

:global(.MuiButtonBase-root.MuiButton-root).medium {
	padding-top: 9px;
	padding-bottom: 9px;
}

.core-btn.medium:has(svg) {
	padding-top: 6px;
	padding-bottom: 6px;
}

:global(.MuiButtonBase-root.MuiButton-root).contained.medium {
	padding-top: 11px;
	padding-bottom: 11px;
}

.core-btn.contained.medium:has(svg) {
	padding-top: 8px;
	padding-bottom: 8px;
}

.core-btn.large {
	padding-top: 12.5px;
	padding-bottom: 12.5px;
}

.core-btn.large:has(svg) {
	padding-top: 9.5px;
	padding-bottom: 9.5px;
}

.core-btn.contained.large {
	padding-top: 14.5px;
	padding-bottom: 14.5px;
}

.core-btn.contained.large:has(svg) {
	padding-top: 11.5px;
	padding-bottom: 11.5px;
}

.core-btn.medium :global(.MuiSvgIcon-root),
.core-btn.large :global(.MuiSvgIcon-root) {
	font-size: 24px;
}

.core-btn svg path {
	transition-duration: 150ms;
}

:global(.MuiButton-root).btn-outlined:focus-visible {
	outline: solid 4px var(--selected-outline-color);
}

:global(.MuiButton-root).btn-outlined.btn-focus-within:focus-within {
	outline: solid 4px var(--selected-outline-color);
}

:global(.MuiButton-root).outlined.btn--primary {
	background: var(--primary-background-color);
	border-color: var(--primary-border-color);
	color: var(--primary-font-color);
}

:global(.MuiButton-root).outlined.btn--primary.core-btn-checked {
	background: var(--primary-hover-background-color);
	border-color: var(--primary-hover-border-color);
	color: var(--primary-hover-font-color);
}

:global(.MuiButton-root).outlined.btn--primary:hover,
:global(.MuiButton-root).outlined.btn--primary.hover,
:global(.MuiButton-root).outlined.btn--primary:focus-visible:not(.btn-outlined),
:global(.MuiButton-root).outlined.btn--primary.btn-focus-within:focus-within:not(.btn-outlined) {
	background: var(--primary-hover-background-color);
	border-color: var(--primary-hover-border-color);
	color: var(--primary-hover-font-color);
}

:global(.MuiButton-root).outlined.btn--primary:active {
	background: var(--primary-active-background-color);
	border-color: var(--primary-active-border-color);
	color: var(--primary-active-font-color);
}

:global(.MuiButton-root).outlined.btn--primary:global(.Mui-disabled) {
	background: var(--primary-disabled-background-color);
	border-color: var(--primary-disabled-border-color);
	color: var(--primary-disabled-font-color);
}

:global(.MuiButton-root).outlined.btn--primary:hover svg path,
:global(.MuiButton-root).outlined.btn--primary.hover svg path,
:global(.MuiButton-root).outlined.btn--primary:focus-visible:not(.btn-outlined) svg path,
:global(.MuiButton-root).outlined.btn--primary.btn-focus-within:focus-within:not(.btn-outlined) svg path {
	stroke: var(--primary-hover-font-color);
}

:global(.MuiButton-root).outlined.btn--primary:active svg path {
	stroke: var(--primary-active-font-color);
}

:global(.MuiButton-root).outlined.btn--primary:global(.Mui-disabled) svg path {
	stroke: var(--primary-disabled-font-color);
}

:global(.MuiButton-root).contained.btn--primary {
	background: var(--primary-hover-background-color);
	color: var(--primary-hover-font-color);
}

:global(.MuiButton-root).outlined.btn--secondary {
	background: var(--secondary-background-color);
	border-color: var(--secondary-border-color);
	color: var(--secondary-font-color);
}

:global(.MuiButton-root).outlined.btn--secondary:hover,
:global(.MuiButton-root).outlined.btn--secondary.hover,
:global(.MuiButton-root).outlined.btn--secondary:focus-visible:not(.btn-outlined),
:global(.MuiButton-root).outlined.btn--secondary.btn-focus-within:focus-within:not(.btn-outlined) {
	background: var(--secondary-hover-background-color);
	border-color: var(--secondary-hover-border-color);
	color: var(--secondary-hover-font-color);
}

:global(.MuiButton-root).outlined.btn--secondary:active {
	background: var(--secondary-active-background-color);
	border-color: var(--secondary-active-border-color);
	color: var(--secondary-active-font-color);
}

:global(.MuiButton-root).outlined.btn--secondary:global(.Mui-disabled) {
	background: var(--secondary-disabled-background-color);
	border-color: var(--secondary-disabled-border-color);
	color: var(--secondary-disabled-font-color);
}

:global(.MuiButton-root).outlined.btn--secondary svg path {
	stroke: var(--secondary-font-color);
}

:global(.MuiButton-root).outlined.btn--secondary:hover svg path,
:global(.MuiButton-root).outlined.btn--secondary.hover svg path,
:global(.MuiButton-root).outlined.btn--secondary:focus-visible:not(.btn-outlined) svg path,
:global(.MuiButton-root).outlined.btn--secondary.btn-focus-within:focus-within:not(.btn-outlined) svg path {
	stroke: var(--secondary-hover-font-color);
}

:global(.MuiButton-root).outlined.btn--secondary:active svg path {
	stroke: var(--secondary-active-font-color);
}

:global(.MuiButton-root).outlined.btn--secondary:global(.Mui-disabled) svg path {
	stroke: var(--secondary-disabled-font-color);
}

:global(.MuiButton-root).contained.btn--secondary {
	background: var(--secondary-hover-background-color);
	color: var(--secondary-hover-font-color);
}

:global(.MuiButton-root).outlined.btn--cancel {
	background: var(--cancel-background-color);
	border-color: var(--cancel-border-color);
	color: var(--cancel-font-color);
}

:global(.MuiButton-root).outlined.btn--cancel:hover,
:global(.MuiButton-root).outlined.btn--cancel.hover,
:global(.MuiButton-root).outlined.btn--cancel:focus-visible:not(.btn-outlined),
:global(.MuiButton-root).outlined.btn--cancel.btn-focus-within:focus-within:not(.btn-outlined) {
	background: var(--cancel-hover-background-color);
	border-color: var(--cancel-hover-border-color);
	color: var(--cancel-hover-font-color);
}

:global(.MuiButton-root).outlined.btn--cancel:active {
	background: var(--cancel-active-background-color);
	border-color: var(--cancel-active-border-color);
	color: var(--cancel-active-font-color);
}

:global(.MuiButton-root).outlined.btn--cancel:global(.Mui-disabled) {
	background: var(--cancel-disabled-background-color);
	border-color: var(--cancel-disabled-border-color);
	color: var(--cancel-disabled-font-color);
}

:global(.MuiButton-root).outlined.btn--cancel svg path {
	stroke: var(--cancel-font-color);
}

:global(.MuiButton-root).outlined.btn--cancel:hover svg path,
:global(.MuiButton-root).outlined.btn--cancel.hover svg path,
:global(.MuiButton-root).outlined.btn--cancel:focus-visible:not(.btn-outlined) svg path,
:global(.MuiButton-root).outlined.btn--cancel.btn-focus-within:focus-within:not(.btn-outlined) svg path {
	stroke: var(--cancel-hover-font-color);
}

:global(.MuiButton-root).outlined.btn--cancel:active svg path {
	stroke: var(--cancel-active-font-color);
}

:global(.MuiButton-root).outlined.btn--cancel:global(.Mui-disabled) svg path {
	stroke: var(--cancel-disabled-font-color);
}

:global(.MuiButton-root).contained.btn--cancel {
	background: var(--cancel-hover-background-color);
	color: var(--cancel-hover-font-color);
}

:global(.MuiButton-root).MuiButton-startIcon {
	margin: 0;
}

.core-btn.icon {
	min-width: 0;
	flex-shrink: 0;
}

:global(.MuiButton-root).outlined.btn--primary.btn-no-focus-background:focus-visible:not(:hover):not(
		.core-btn-checked
	):not(.btn-outlined),
:global(.MuiButton-root).outlined.btn--primary.btn-no-focus-background.btn-focus-within:focus-within:not(:hover):not(
		.core-btn-checked
	):not(.btn-outlined) {
	background: var(--primary-background-color);
	border-color: var(--primary-border-color);
	color: var(--primary-font-color);
}

:global(.MuiButton-root).outlined.btn--primary.btn-no-focus-background:focus-visible:not(:hover):not(
		.core-btn-checked
	):not(.btn-outlined)
	svg
	path,
:global(.MuiButton-root).outlined.btn--primary.btn-no-focus-background.btn-focus-within:focus-within:not(:hover):not(
		.core-btn-checked
	):not(.btn-outlined)
	svg
	path {
	fill: var(--primary-font-color);
}

:global(.MuiButton-root).outlined.btn--secondary.btn-no-focus-background:focus-visible:not(:hover):not(
		.core-btn-checked
	):not(.btn-outlined),
:global(.MuiButton-root).outlined.btn--secondary.btn-no-focus-background.btn-focus-within:focus-within:not(
		.btn-outlined
	) {
	background: var(--secondary-background-color);
	border-color: var(--secondary-border-color);
	color: var(--secondary-font-color);
}

:global(.MuiButton-root).outlined.btn--secondary.btn-no-focus-background:focus-visible:not(:hover):not(
		.core-btn-checked
	):not(.btn-outlined)
	svg
	path,
:global(.MuiButton-root).outlined.btn--secondary.btn-no-focus-background.btn-focus-within:focus-within:not(
		.btn-outlined
	)
	svg
	path {
	fill: var(--secondary-font-color);
}

:global(.MuiButton-root).outlined.btn--cancel.btn-no-focus-background:focus-visible:not(:hover):not(
		.core-btn-checked
	):not(.btn-outlined),
:global(.MuiButton-root).outlined.btn--cancel.btn-no-focus-background.btn-focus-within:focus-within:not(:hover):not(
		.core-btn-checked
	):not(.btn-outlined) {
	background: var(--cancel-background-color);
	border-color: var(--cancel-border-color);
	color: var(--cancel-font-color);
}

:global(.MuiButton-root).outlined.btn--cancel.btn-no-focus-background:focus-visible:not(:hover):not(
		.core-btn-checked
	):not(.btn-outlined)
	svg
	path,
:global(.MuiButton-root).outlined.btn--cancel.btn-no-focus-background.btn-focus-within:focus-within:not(:hover):not(
		.core-btn-checked
	):not(.btn-outlined)
	svg
	path {
	fill: var(--cancel-font-color);
}

.btn-hover-highlight {
	box-shadow: 0 0 0 0 #e0daff;
	transition: box-shadow 0.2s ease-in-out;
}

.btn-hover-highlight:hover,
.btn-hover-highlight:focus-visible {
	box-shadow: 0 0 0 3px #e0daff;
}

@keyframes shadowClick {
	0% {
		box-shadow: 0 0 0 3px #e0daff;
	}
	30% {
		box-shadow: 0 0 0 0 #e0daff;
	}
	70% {
		box-shadow: 0 0 0 1.5px #e0daff;
	}
	100% {
		box-shadow: 0 0 0 3px #e0daff;
	}
}

.btn-hover-highlight:not(.core-btn-checked):active {
	animation: shadowClick 0.4s ease-in-out forwards;
}

.btn-disabled-cursor:disabled {
	cursor: not-allowed;
	pointer-events: auto;
}

.icon-button {
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 2px; /* UX team wants 2px border radius for focus outline */
	padding: 3px;
}

.icon-button.medium svg,
.icon-button.large svg {
	font-size: 24px;
}

.icon-button.small svg {
	font-size: 22px;
}

.icon-button.dark svg {
	color: white;
}

.icon-button:disabled svg {
	color: #c2bbcf;
}

.icon-button.dark:disabled svg {
	color: #8c8c8c;
}

.icon-button:hover:not(:disabled):not(:active):not(.active) {
	background: #ececec;
}

.icon-button.dark:hover:not(:disabled):not(:active):not(.active) {
	background: #737373;
}

.icon-button.dark:active:not(:disabled),
.icon-button.dark.active:not(:disabled) {
	background: #707070;
}

.hiddenInput {
	position: absolute;
	width: 0;
	height: 0;
	opacity: 0;
	pointer-events: none;
}

.hiddenInput:focus + .core-btn {
	outline: 2px solid var(--focus-outline-color-dark);
	outline-offset: 2px;
}
